import { useEffect, useState } from "react";
import '../../styles/App.css'
import { nanoid } from "nanoid";
import SingleCard from "./components/SingleCard";
import Celebration from "./components/Celebration";
import ShowConfetti from "./components/Confetti";
import { useParams } from "react-router";
import axios from "axios";
import Footer from "../../includes/Footer";
import Header from "../../includes/Header";
import MessageCouple from "./components/Message/MessageCouple";
import { toast } from "react-toast";

const baseURL = "https://api-landing.edianogama.com";
const max_images = 10;
const numbers = Array.from({ length: max_images }, (_, index) => {
    const number = index + 1;
    return (number < 10) ? `0${number}` : `${number}`;
});

function Memory() {
    const [cardImages, setCardsImages] = useState([]);
    const [histories, setHistories] = useState([]);

    const [cards, setCards] = useState([])
    const [turns, setTurns] = useState(0)
    const [choiceOne, setChoiceOne] = useState(null)
    const [choiceTwo, setChoiceTwo] = useState(null)
    const [disabled, setDisabled] = useState(false)
    const [highScore, setHighScore] = useState(0)
    const [matched, setMatched] = useState(0)
    const [celebrationStatus, setCelebrationStatus] = useState(false)
    const [openMessageCouple, setOpenMessageCouple] = useState(false)
    const [messageText, setMessageText] = useState();
    const [coupleName, setCoupleName] = useState('');
    const [coupleImage, setCoupleImage] = useState();
    const [elapsedTime, setTime] = useState(undefined)
    const [intervalId, setIntervalId] = useState(undefined)
    const [animateCollapse, setAnimateCollapse] = useState(false);

    const { slug } = useParams(); 
    const [coupleData, setCoupleData] = useState(null);

    function secureShuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(nanoid(64) * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }
    function pickRandomImages(cardImages, count) {
        if (count > cardImages.length) {
            console.error("");
            return [];
        }
        const shuffledImages = [...cardImages].sort(() => {
            const randomA = nanoid(16);
            const randomB = nanoid(16);
            return randomA.localeCompare(randomB);
        });
        const selectedImages = shuffledImages.slice(0, count);
    
        return selectedImages;
    }
    
    const onCloseMessage = () => {
        setOpenMessageCouple(false);
    }
    const organizeData = (data) => {
        const images = data.couple_photos;
            setCoupleName(data.title);
            let cardFeatured = [];
            let historyFeatured = [];
            images.forEach((photo, index) => {
                cardFeatured.push({ src: baseURL +'/'+  photo.photo_url, matched: false, history: index + 1 });
                historyFeatured.push({ id: index + 1, description: photo.description })
            });
            setCardsImages(cardFeatured);
            setHistories(historyFeatured);
    }
    const shuffledCards = () => {
        if (!cardImages.length) {
            toast.info("Aguardando carregamento das imagens. Dúvidas: contato@nossasmemorias.online", {
                position: "top-center"
              });
        }
        const selectedImages = pickRandomImages(cardImages, cardImages.length);

        const shuffledCards = [...selectedImages, ...selectedImages]
            .sort(() => {
                const randomA = nanoid(16); 
                const randomB = nanoid(16);
                return randomA.localeCompare(randomB);
            })
            .map((card) => ({ ...card, id: Math.random() }));
        secureShuffleArray(numbers);

        setChoiceOne(null);
        setChoiceTwo(null);
        setCards(shuffledCards);
        setTurns(0);
        setMatched(0);
        setCelebrationStatus(false);
        setTime(undefined);
        clearInterval(intervalId);
        setAnimateCollapse(true);

        setTimeout(() => {
            setAnimateCollapse(false);
        }, 1200);
    };

    const handleNewGame = () => {
        const audioElement = new Audio("../audio/start.mp3");
        audioElement.play();
        setIntervalId(undefined)
        shuffledCards();
    };
   


    const handleChoice = (card) => {
        choiceOne ? setChoiceTwo(card) : setChoiceOne(card)
        if (elapsedTime === undefined) handleTime(true)
    }
    const handleTime = (start) => {
        if (start) {
            if (intervalId === undefined) {
                const newIntervalId = setInterval(() => {
                    setTime((elapsedTime) => (elapsedTime || 0) + 1);
                }, 1000);
                setIntervalId(newIntervalId);
            }
        } else {
            if (intervalId !== undefined) {
                clearInterval(intervalId);
                setIntervalId(undefined);
            }
        }
    };

    useEffect(() => {

        if (choiceOne && choiceTwo) {
            setDisabled(true)
            if (choiceOne.src === choiceTwo.src) {
                const history = histories.find(h => h.id ===  choiceOne.history);
                soundEffect.src = "../audio/match.wav"
                soundEffect.play()
                setMessageText(history);
                setCoupleImage(choiceOne.src);
                setOpenMessageCouple(true);
                setCards(prevCards => {
                    return prevCards.map(card => {
                        if (card.src === choiceOne.src) {
                            return {
                                ...card, matched: true
                            }
                        } else {
                            return card
                        }
                    })
                })
                resetTurn()
                setMatched(prevMatched => prevMatched + 2)
            } else {
                // soundEffect.src = "audio/fail.wav"
                // soundEffect.play()
                setTimeout(() => resetTurn(), 1000)
            }
        } else if (choiceOne) {
            soundEffect.src = "../audio/swap.wav"
            soundEffect.play()
        }
    }, [choiceOne, choiceTwo])

    const resetTurn = () => {
        setChoiceOne(null)
        setChoiceTwo(null)
        setTurns(prevTurns => prevTurns + 1)
        setDisabled(false)
    }
    const soundEffect = new Audio();
    soundEffect.autoplay = true;

    useEffect(() => {
        if (matched === cards.length && turns) {
            // Game over
            const m_highscore = window.localStorage.getItem("highscore")
            const runtime = window.localStorage.getItem("runtime")
            handleTime(false)
            if (m_highscore === null || turns < Number(m_highscore) || (turns === Number(m_highscore) && elapsedTime < runtime)) {
                // New highscore
                window.localStorage.setItem("highscore", turns)
                window.localStorage.setItem("runtime", elapsedTime)
                setHighScore(turns)
            }
            soundEffect.src = "../audio/celebration.mp3"
            soundEffect.play()
            setCelebrationStatus(true)
        }
    }, [matched])

    useEffect(() => {
       shuffledCards();
    }, [cardImages])

    useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get(baseURL+ `/v1/casais/${slug}`); 
            setCoupleData(response.data.data);
            setTimeout(() => {
                organizeData(response.data.data); 
            }, 1000);
          } catch (error) {
            console.error('Erro ao buscar dados:', error);
          }
        };

        fetchData();
        const m_highscore = window.localStorage.getItem("highscore") || 0
        setHighScore(m_highscore)

      }, [slug]);

    return (
        <>
        <Header />
        <div className="App memory-casal px-5 md:px-0">
            {celebrationStatus && (
                <Celebration highScore={highScore} elapsedTime={elapsedTime} />
            )}
             {openMessageCouple && (
                <MessageCouple highScore={highScore} messageText={messageText} coupleImage={coupleImage} coupleName={coupleName} onClose={onCloseMessage} />
            )}
            {celebrationStatus && <ShowConfetti />}
            <h1 className="md:text-5xl py-4">Relembre os nossos momentos</h1>
            <button className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white  dark:focus:ring-primary-900" onClick={handleNewGame}>Novo jogo</button>
            {/* <button id="theme-toggle" onClick={toggleTheme}>
                dark
            </button> */}
            <div className={`card-grid py-4 ${animateCollapse ? 'collapse-animation' : ''}`}>
                {cards.map((card) => (
                    <SingleCard
                        key={card.id}
                        card={card}
                        handleChoice={handleChoice}
                        flipped={card === choiceOne || card === choiceTwo || card.matched}
                        disabled={disabled}
                    />
                ))}
            </div>
            <div className="bubbling-heart">
                <div><i className="fa fa-heart fa-5x"></i></div>
                <div><i className="fa fa-heart fa-5x"></i></div>
                <div><i className="fa fa-heart fa-5x"></i></div>
                <div><i className="fa fa-heart fa-5x"></i></div>
            </div>
            <div class="box">
                <div class="box__header">
                    <h3 class="box__header-title">Meu placar</h3>
                </div>
                <div class="box__body">
                    <div class="stats stats--main">
                    <div class="stats__amount">{turns}</div>
                    <div class="stats__caption">Tentativas</div>
                    <div class="stats__change">
                        
                        <div class="stats__value stats__value--positive">{window.localStorage.getItem("runtime") || 0}</div>
                        <div class="stats__period">Tempo total do jogo</div>
                    </div>
                    </div>

                    <div class="stats">
                    <div class="stats__amount">{elapsedTime || "Não iniciado"}</div>
                    <div class="stats__caption">Tempo gasto</div>
                    <div class="stats__change">
                    <div class="stats__value stats__value--positive">{highScore}</div>
                    <div class="stats__period">Pontos</div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
        </>
    );
}
export default Memory
